"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCanvasBlob = void 0;
const getCanvasBlob = async (canvas) => {
    if (typeof canvas.toBlob !== "undefined") {
        return await new Promise(resolve => {
            canvas.toBlob(resolve, "image/jpeg");
        });
    }
    else {
        // unsupported browser, IE, etc.
        // https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob#Polyfill
        const binStr = atob(canvas.toDataURL("image/jpeg").split(",")[1]);
        const len = binStr.length;
        const arr = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
            arr[i] = binStr.charCodeAt(i);
        }
        return new Blob([arr], { type: "image/jpeg" });
    }
};
exports.getCanvasBlob = getCanvasBlob;
//# sourceMappingURL=getCanvasBlob.js.map